import React, { useEffect, useState } from "react";
import api from "../../api/api.js";
import { useNavigate } from "react-router-dom";
import { Reviews_Route } from "../../router/routes.js";

function Orders() {
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        api.get("/orders")
            .then((json) => {
                if (json.data.status === "success" && json.data.data) {
                    const sortedOrders = [...json.data.data].sort(
                        (a, b) => b.number - a.number // Сортування по номеру
                    );
                    setOrders(sortedOrders);
                } else {
                    throw new Error("Неверный формат данных");
                }
            })
            .catch((err) => setError(err.message))
            .finally(() => setLoading(false));
    }, []);


    if (loading) {
        return <div className="orders-container">Загрузка заказов...</div>;
    }

    if (error) {
        return <div className="orders-container">Ошибка: {error}</div>;
    }

    return (
        <div className="orders-container">
            <button onClick={() => navigate(Reviews_Route)}>Reviews</button>
            <h2>Order List</h2>
            {orders.length === 0 ? (
                <p>No orders available.</p>
            ) : (
                <table className="orders-table">
                    <thead>
                    <tr>
                        <th>Order Number</th>
                        <th>Give</th>
                        <th>Get</th>
                        <th>Give Amount</th>
                        <th>Get Amount</th>
                        <th>Type</th>
                        <th>Rate</th>
                        <th>Location</th>
                        <th>Name</th>
                        <th>Additional</th>
                        <th>Email</th>
                        <th>Telegram</th>
                        <th>Phone</th>
                        <th>Creation Date</th>
                    </tr>
                    </thead>
                    <tbody>
                    {orders.map((order) => (
                        <tr key={order._id}>
                            <td>{order.number}</td>
                            <td>{order.tokenGive}</td>
                            <td>{order.tokenGet}</td>
                            <td>{order.amountGive}</td>
                            <td>{order.amountGet}</td>
                            <td>{order.type}</td>
                            <td>{order.course}</td>
                            <td>{order.location}</td>
                            <td>{order.name}</td>
                            <td>{order.additional}</td>
                            <td>{order.email}</td>
                            <td>{order.telegram}</td>
                            <td>{order.numberMess}</td>
                            <td>
                                {order.createdAt
                                    ? new Date(order.createdAt).toLocaleString()
                                    : "-"}
                            </td>
                        </tr>
                    ))}
                    </tbody>

                </table>
            )}
        </div>
    );
}

export default Orders;
